<section class="installers-page container">
  <h1 class="installers-page__header">
    {{ 'global.installers' | translate }}
  </h1>
  <div class="installers-page__content">
    <pwj-solutions-people-browse
      filterType="INSTALLER"
      noContentMessageKey="industries.noIndustries" />
  </div>
</section>
